import { render, staticRenderFns } from "./support-file-upload.vue?vue&type=template&id=a56ed3aa&scoped=true&"
import script from "./support-file-upload.vue?vue&type=script&lang=ts&"
export * from "./support-file-upload.vue?vue&type=script&lang=ts&"
import style0 from "./support-file-upload.vue?vue&type=style&index=0&id=a56ed3aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56ed3aa",
  null
  
)

export default component.exports